import RestResource from '../rest.service';
export default class StatisticsService extends RestResource {
  constructor(api) {
    super(api, 'negotiations/statistics', 'api');
  }
}
